import type { ActionTree } from 'vuex';
import { SigningAction, signingNamespace } from '../signing/store/signing.constants';
import type { RootState } from './root.types';
import { RootAction, RootMutation } from './root.types';

export const actions: ActionTree<RootState, RootState> = {
  [RootAction.SetIds](
    { dispatch, commit, state },
    payload: {
      signingPageId: string;
      recipientId?: string;
      authId: string;
      userId?: string;
      videoReminderId?: string;
    }
  ) {
    if (payload.recipientId !== state.recipientId) {
      dispatch(`${signingNamespace}/${SigningAction.ResetBankId}`);
    }
    if (payload.userId) {
      dispatch(RootAction.SetPreviewMode, true);
    }
    commit(RootMutation.SetIds, payload);
  },
  [RootAction.SetPreviewMode]({ commit }, isPreview: boolean) {
    commit(RootMutation.SetPreviewMode, isPreview);
  },
  [RootAction.SetPreviewExpired]({ commit }, expired: boolean) {
    commit(RootMutation.SetPreviewExpired, expired);
  },
  [RootAction.SetPusherConnected]({ commit }, connected: boolean) {
    commit(RootMutation.SetPusherConnected, connected);
  },
};
